import App, { RequireAuth } from "@/App.tsx";
import AnonymousLayout from "@/layouts/AnonymousLayout.tsx";
import AuthenticatedPortalLayout from "@/layouts/AuthenticatedPortalLayout.tsx";
import RootErrorBoundary from "@/routes/RootErrorBoundary.tsx";
import { RouterAdapter } from "@/routes/RouterAdapter.tsx";
import { anonymousRoutes } from "@/routes/configs/anonymous.routes.tsx";
import { authenticatedRoutes } from "@/routes/configs/authenticated.routes.tsx";
import { generateRouteObjects } from "@/routes/utils/route.utils.tsx";
import { createBrowserRouter } from "react-router-dom";

export const router = createBrowserRouter([
  {
    // Выше <App />: ранние возвраты App рендерят ui-kit и без провайдера упадут.
    element: (
      <RouterAdapter>
        <App />
      </RouterAdapter>
    ),
    errorElement: <RootErrorBoundary />,
    children: [
      {
        element: <AnonymousLayout />,
        children: generateRouteObjects(anonymousRoutes),
      },
      {
        element: (
          <RequireAuth>
            <AuthenticatedPortalLayout />
          </RequireAuth>
        ),
        children: generateRouteObjects(authenticatedRoutes),
      },
    ],
  },
]);
